module.exports = __webpack_public_path__ + "static/img/none.e3ee820.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/none.png
// module id = OSFX
// module chunks = 1